<template>
  <div class="home">
    <Banner></Banner>
    <AboutTo></AboutTo>
    <List></List>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import AboutTo from "../components/AboutTo";
import List from "../components/List";
import { tempConfig } from "../store/interface";

export default {
  name: "Home",
  data() {
    return {
      tempSett: tempConfig
    };
  },
  components: {
    Banner,
    AboutTo,
    List
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.tempSett = val;
    }
  }
};
</script>
